import { useState, useEffect } from "react";
import {
  getInternalCampaignList,
} from "../../../../services/ApiService";
import { useSelector } from "react-redux";
import { handleApi } from "../../../../utils/authentication";
import { toast } from "react-toastify";
import InternalCampaignModal from "./InternalCampaignModal";

const UnassociatedCampainTable = ({
  campaignList,
  setShowUnassociatedCampainModal
}) => {
  //   const [managerResults, setManagerResults] = useState([]);
  const [loading, setLoading] = useState({}); // Change to object to track each button's loading state
  //   const [managerId, setManagerId] = useState("");

  const [internalCampaigns, setInternalCampaigns] = useState();
  const [selectedLinkedinCampaign,setSelectedLinkedinCampaign] = useState();
  const [internalCampaignModal, setInternalCampaignModal] = useState(false);

  const user = useSelector((state) => state?.user);


  const headers = [
    { label: "Name", key: "name" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },
    { label: "Actions", key: "actions" },
  ];

  const fetchInternalCampaignList = async (account, index) => {
    setLoading((prev) => {
      return { ...prev, [index]: true };
    });
    const result = await getInternalCampaignList(user);
    if (result?.success) {
      setInternalCampaigns(result?.data?.campaigns_list);
      if(result?.data?.campaigns_list.length>0){
        setInternalCampaignModal(true);
      }else{
        toast.error("No internal campaigns found for the selected program. Please check the program details or create a campaign to proceed.");
      }
  
    }
    setSelectedLinkedinCampaign(account);
    setLoading((prev) => {
      return { ...prev, [index]: false };
    });
  };

  useEffect(() => {
    const setLodingtext = () => {
      let loader = {};
      if (campaignList?.length > 0) {
        for (let i = 0; i < campaignList?.length; i++) {
          loader[i] = false;
        }
      }
      setLoading(loader);
     
    };

    setLodingtext();
  }, []);


  
  return (
    <>
      <div className="card-lg  bg-light">
        <div className="table-responsive text-nowrap card-body py-0">
          <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
            <thead>
              <tr className="fw-bold text-muted bg-light">
                {headers?.map((header) => (
                  <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {campaignList?.length === 0 ? (
                <tr>
                  <td
                    colSpan={headers.length}
                    className="text-center text-muted"
                  >
                    No data available
                  </td>
                </tr>
              ) : (
                campaignList?.map((account, index) => {
                  return (
                    <tr className="text-muted" key={index}>
                      {/* <td>{index + 1}</td> */}
                      <td>{account.campaign_name}</td>
                      <td>{account.start_date}</td>
                      <td>{account.end_date}</td>
                      <td className="d-flex justify-content-end">
                        <button
                          className="btn btn-sm rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center "
                          style={{ width: "150px" }}
                          // onClick={() => handleManager(account.id, index)}
                          onClick={() =>
                            fetchInternalCampaignList(account, index)
                          }
                          disabled={loading[index]} // Disable button while loading
                        >
                          {loading[index] ? (
                            <>
                              <span className="">Please Wait...</span>
                            </>
                          ) : (
                            <span className="">Associate</span>
                          )}
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
      {internalCampaigns?.length > 0
        && <InternalCampaignModal
          internalCampaigns={internalCampaigns}
          show={internalCampaignModal}
          setShow={setInternalCampaignModal}
          externalCampaign={selectedLinkedinCampaign}
          loading={loading}
          setShowUnassociatedCampainModal={setShowUnassociatedCampainModal}
        />}
    </>
  );
};

export { UnassociatedCampainTable };
